import { useEffect } from 'react';
import { AddSubscriptionProductParameterType } from './useGetProductFromParent';
import { AxiosResponse } from 'axios';

export const useEmitApiResult = (
  productParameter: AddSubscriptionProductParameterType | undefined,
  response: AxiosResponse | null
) => {

  useEffect(() => {
    if (!productParameter) return;

    window.parent.postMessage({action: 'apiResult', type: response}, '*');
  }, [productParameter, response]);
};
